const checklisttemplate = {
	module: "Generell sjekkliste",
	list_title: "Sjekklistemaler",
	new_title: "Legg til sjekklistemal",
	edit_title: "Rediger sjekklistemal",
	id: "ID",
	title: "Tittel",
	description: "Beskrivelse",
	checklist_type: "Sjekkliste type",
	formula_type: "Formeltype",
	not_affect_status: "Ikke berørt status",
	checklist_template_api_id: "Sjekkliste mal API",
	machine_group: "Maskingruppe",
	status: "Status",
	text_field: "Tekstfelt",
	text_area: "Tekstområde",
	radio: "Radio",
	select: "Velg",
	signature: "Signatur",
	label: "Punkt etikett",
	checkbox: "Avkrysningsboks",
	date: "Dato",
	time: "Klokkeslett",
	divider: "Skillelinje",
	component: "Komponentboks",
	checkpoint_123s: "Sjekkpunkt 123S",
	checkpoint_radio_status: "Anbefalt bruk status",
	checkpoint_f1_123s: "Radio 0-3, NA",
	checkpoint_f2_123s: "Radio A-D, NA",
	checkpoint_f3_123s: "Radio K R",
	checkpoint_f4_123s: "Formula4 Checkpoint 123S",
	panel: "Panelet",
	comments: "Kommentar",
	switch: "Bytte om",
	file: "Fil",
	grid: "Nett",
	value: "Verdi",
	templateHeader: "PDF Hode",
	updated_on: "Oppdatert",
	available_templates: "Tilgjengelige maler",
	import_success: "Mal importert",
	import_failed: "Malimport feilet",
};
export default checklisttemplate;